import React from 'react';
import { FilterCollapsableWrapper } from '../../FiltersWrappers/FilterCollapsableWrapper/FilterCollapsableWrapper';
import CustomAutocomplete from './CustomAutocomplete/CustomAutocomplete';
import type { AutocompleteOptionsSource } from './CustomAutocomplete/AutocompleteOptionsSource';

type DisableScroll = ((disable: boolean) => void) | boolean;

interface AutocompleteMultipleChoiceProps {
  filterType: string;
  disableScroll?: DisableScroll;
  noBottomDivider?: boolean;
  optionsSource?: AutocompleteOptionsSource;
}

export const AutocompleteMultipleChoice = ({ filterType, disableScroll, noBottomDivider, optionsSource }: AutocompleteMultipleChoiceProps) => {
  const handleDisableScroll = typeof disableScroll === 'function' ? disableScroll : () => undefined;

  return (
    <>
      <FilterCollapsableWrapper
        filterType={filterType}
        noBottomDivider={noBottomDivider}
      >
        <CustomAutocomplete
          filterType={filterType}
          disableScroll={handleDisableScroll}
          optionsSource={optionsSource}
        />
      </FilterCollapsableWrapper>
    </>
  );
};
